import { Select } from 'antd';

import { Form, WrapperSelect } from 'common/components';

import { useGetEnumsByEnumName } from 'hooks';
import {
  getClassesByCategoryAndSubcategory,
  getSubcategoriesByCategory,
} from 'pages/product-full-view/components/product-new-detail-view/hierarchyCategoryUtils';
import { CATEGORY_FIREARMS } from 'pages/product-full-view/components/product-new-detail-view/constants';

import sortByKey from 'utils/sortByKey';

export const FormItemCategory = () => {
  const categoriesEnum = useGetEnumsByEnumName('CategoriesEnum');
  const form = Form.useFormInstance();

  const handleResetValue = () => {
    // When category is selected, clear dependent fields
    form.resetFields(['subCategory', 'class']);
  };

  return (
    <Form.Item
      label='Category'
      name='category'
      rules={[
        {
          required: true,
          message: 'Category is required',
        },
      ]}
    >
      <WrapperSelect
        showSearch
        listHeight={140}
        onSelect={handleResetValue}
        onClear={handleResetValue}
        filterOption={(input, option) =>
          option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
        }
      >
        {sortByKey(categoriesEnum, 'enumDisplayName')?.map(
          (property, index) => (
            <Select.Option
              value={property.enumDisplayName}
              key={property.enumDisplayName + index}
            >
              {property.enumDisplayName
                ? property.enumDisplayName
                : property.enumDescription}
            </Select.Option>
          )
        )}
      </WrapperSelect>
    </Form.Item>
  );
};

export const FormItemSubCategory = () => {
  const categoriesEnum = useGetEnumsByEnumName('SubCategoriesEnum');

  const form = Form.useFormInstance();
  const category = Form.useWatch('category', form);

  const isDisabled = !category;
  let filteredEnums = categoriesEnum;
  let preserveOrder = false;

  if (category) {
    const validSubcategories = getSubcategoriesByCategory(category);
    filteredEnums = validSubcategories
      .map((subcategory) =>
        categoriesEnum.find((enumItem) => enumItem.enumCode === subcategory)
      )
      .filter(Boolean);
    preserveOrder = true;
  }

  const handleResetValue = () => {
    // When subcategory is selected, clear class
    form.resetFields(['class']);
  };

  return (
    <Form.Item
      label='Sub Category'
      name='subCategory'
      rules={
        filteredEnums?.length > 0 && Boolean(category)
          ? [
              {
                required: true,
                message: 'Sub Category is required',
              },
            ]
          : []
      }
    >
      <WrapperSelect
        showSearch
        listHeight={140}
        onSelect={handleResetValue}
        onClear={handleResetValue}
        disabled={isDisabled}
        filterOption={(input, option) =>
          option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
        }
      >
        {(preserveOrder
          ? filteredEnums
          : sortByKey(filteredEnums, 'enumDisplayName')
        )?.map((property, index) => (
          <Select.Option
            value={property.enumDisplayName}
            key={property.enumDisplayName + index}
          >
            {property.enumDisplayName
              ? property.enumDisplayName
              : property.enumDescription}
          </Select.Option>
        ))}
      </WrapperSelect>
    </Form.Item>
  );
};

export const FormItemClass = () => {
  const categoriesEnum = useGetEnumsByEnumName('ClassEnum');

  const form = Form.useFormInstance();
  const category = Form.useWatch('category', form);
  const subCategory = Form.useWatch('subCategory', form);

  if (category === CATEGORY_FIREARMS) {
    return null;
  }

  const isDisabled = !category || !subCategory;
  let filteredEnums = categoriesEnum;

  if (category && subCategory) {
    const validClasses = getClassesByCategoryAndSubcategory(
      category,
      subCategory
    );
    filteredEnums = categoriesEnum.filter((enumItem) =>
      validClasses.includes(enumItem.enumCode)
    );
  }

  return (
    <Form.Item label='Class' name='class'>
      <WrapperSelect
        showSearch
        listHeight={140}
        disabled={isDisabled}
        filterOption={(input, option) =>
          option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
        }
      >
        {sortByKey(filteredEnums, 'enumDisplayName')?.map((property, index) => (
          <Select.Option
            value={property.enumDisplayName}
            key={property.enumDisplayName + index}
          >
            {property.enumDisplayName
              ? property.enumDisplayName
              : property.enumDescription}
          </Select.Option>
        ))}
      </WrapperSelect>
    </Form.Item>
  );
};
